import React, { useState } from "react";
import { NavLink, Link } from "react-router-dom";
import "./Navbar.css";

function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => setMenuOpen((prev) => !prev);
  const closeMenu = () => setMenuOpen(false);

  const scrollToTop = () => {
    // Try all common scroll containers
    const scrollElement = document.scrollingElement || document.documentElement;

    if (scrollElement) {
      scrollElement.scrollTop = 0;
    }

    if (document.body) {
      document.body.scrollTop = 0;
    }

    // Fallback to window
    window.scrollTo(0, 0);
  };

  const handleNavClick = () => {
    closeMenu();
    scrollToTop();
  };

  return (
    <>
      {/* NAVBAR */}
      <nav className="navbar">
        <div className="nav-inner">
          {/* LEFT: LOGO + DESKTOP LINKS */}
          <div className="navbar-left">
            <Link to="/" className="logo-link" onClick={handleNavClick}>
              <img
                src={require("./assets/beszELJ_logo2.png")}
                alt="BeszÉLJ logó"
                className="logo"
              />
            </Link>

            <div className="desktop-links">
              <NavLink
                to="/"
                exact
                activeClassName="active"
                onClick={handleNavClick}
              >
                Otthon
              </NavLink>
              <NavLink
                to="/about"
                activeClassName="active"
                onClick={handleNavClick}
              >
                Rólunk
              </NavLink>
              <NavLink
                to="/events"
                activeClassName="active"
                onClick={handleNavClick}
              >
                Események
              </NavLink>
              <NavLink
                to="/stuttering"
                activeClassName="active"
                onClick={handleNavClick}
              >
                A dadogásról
              </NavLink>
              <NavLink
                to="/faq"
                activeClassName="active"
                onClick={handleNavClick}
              >
                Kérdések
              </NavLink>
            </div>
          </div>

          {/* RIGHT SIDE */}
          <div className="navbar-right">
            <Link
              to="/membership"
              className="btn-primary"
              onClick={handleNavClick}
            >
              Legyél tagunk
            </Link>
            <span className="desktop-divider"></span>
            <NavLink
              to="/support"
              className="btn-support"
              activeClassName="active"
              onClick={handleNavClick}
            >
              Támogass minket
            </NavLink>

            {/* MOBILE HAMBURGER */}
            <button
              type="button"
              aria-label="Menü"
              className={`hamburger ${menuOpen ? "active" : ""}`}
              onClick={toggleMenu}
            >
              <span></span>
              <span></span>
              <span></span>
            </button>
          </div>
        </div>
      </nav>

      {/* MOBILE DROPDOWN WRAPPER — FIXED UNDER NAVBAR */}
      <div className="mobile-menu-wrapper">
        <div className={`mobile-menu ${menuOpen ? "open" : ""}`}>
          <div className="mobile-buttons">
            <Link
              to="/membership"
              className="btn-primary"
              onClick={handleNavClick}
            >
              Legyél tagunk
            </Link>

            <span className="mobile-divider"></span>

            <Link
              to="/support"
              className="btn-support"
              onClick={handleNavClick}
            >
              Támogass minket
            </Link>
          </div>

          <nav className="mobile-links">
            <NavLink
              to="/"
              exact
              activeClassName="active"
              onClick={handleNavClick}
            >
              Otthon
            </NavLink>
            <NavLink
              to="/about"
              activeClassName="active"
              onClick={handleNavClick}
            >
              Rólunk
            </NavLink>
            <NavLink
              to="/events"
              activeClassName="active"
              onClick={handleNavClick}
            >
              Események
            </NavLink>
            <NavLink
              to="/stuttering"
              activeClassName="active"
              onClick={handleNavClick}
            >
              A dadogásról
            </NavLink>
            <NavLink
              to="/faq"
              activeClassName="active"
              onClick={handleNavClick}
            >
              Kérdések
            </NavLink>
          </nav>
        </div>
      </div>
    </>
  );
}

export default Navbar;
